import React from 'react';
import { List } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import LyricsColorListItem from './inputs/LyricsColorListItem';
import LyricsFontListItem from './inputs/LyricsFontListItem';
import LyricsBoldListItem from './inputs/LyricsBoldListItem';
import LyricsShadowListItem from './inputs/shadow/LyricsShadowListItem';
import LyricsGlowListItem from './inputs/glow/LyricsGlowListItem';
import LyricsSizeListItem from './inputs/LyricsSizeListItem';
import LyricsPositionListItem from './inputs/LyricsPositionListItem';
import LyricsAnchorListItem from './inputs/LyricsAnchorListItem';

const styles = theme => ({
    rootList: {
        marginBottom: theme.spacing(2)
    }
});

class LyricsStyleEditor extends React.Component {

    render() {
        const { classes } = this.props;

        return (
            <List
                className={classes.rootList}
                dense
                disablePadding
            >
                {/* Render the control for lyrics color */}
                <LyricsColorListItem />

                {/* Render the control for lyrics font */}
                <LyricsFontListItem />

                {/* Render the control for lyrics bold style */}
                <LyricsBoldListItem />

                {/* Render the control for lyrics size */}
                <LyricsSizeListItem />

                {/* Render the control for lyrics position */}
                <LyricsPositionListItem />

                {/* Render the control for lyrics anchor */}
                <LyricsAnchorListItem />

                {/* Render the control for lyrics glow */}
                <LyricsGlowListItem />

                {/* Render the control for lyrics shadow */}
                <LyricsShadowListItem />
            </List>
        );
    }
}

export default withStyles(LyricsStyleEditor, styles);